import {event} from "./selection/on";

export default function() {
  var current = event, source;
  while (source = current.sourceEvent) current = source;
  return current;
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-selection/src/sourceEvent.js
// module id = ../../../../d3-selection/src/sourceEvent.js
// module chunks = 4